import {  Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout/layout.component';

import { LoginComponent } from './account/login/login.component';
import { RegisterComponent } from './account/register/register.component';
import { VerificationComponent } from './account/verification/verification.component';
import { ConfirmationComponent } from './account/confirmation/confirmation.component';
import { MfaComponent } from './account/mfa/mfa.component';
import { AuthGuard } from './guards/auth.guard';
import { RegisterDevelopmentComponent } from './account/register-development/register-development.component';
import { CheckTokenGuard } from './guards/check.token.guard';
import { ResetPasswordComponent } from './account/reset-password/reset-password.component';

export const routes: Routes = [
    { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.route').then(mod => mod.PAGE_ROUTES)},

    // Auth
    { path: 'account-login', canActivate: [CheckTokenGuard , AuthGuard], component: LoginComponent },
    { path: 'account-verification', canActivate: [CheckTokenGuard, AuthGuard], component: VerificationComponent },
    { path: 'account-register', canActivate: [CheckTokenGuard, AuthGuard], component: RegisterComponent },
    { path: 'account-register-development', canActivate: [CheckTokenGuard, AuthGuard], component: RegisterDevelopmentComponent },
    { path: 'account-reset-password', canActivate: [CheckTokenGuard, AuthGuard], component: ResetPasswordComponent },
    { path: 'account-confirmation', canActivate: [CheckTokenGuard, AuthGuard], component: ConfirmationComponent},
    { path: 'account-mfa', canActivate: [CheckTokenGuard, AuthGuard], component: MfaComponent },
];


